/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceConnector
 */
export interface DeviceConnector {
    /**
     *
     * @type {string}
     * @memberof DeviceConnector
     */
    deviceIdentity?: string;
    /**
     * Optional list of connector indices to apply the pricing schedule to. If null, then apply
     * pricing schedule to all connectors of device
     * @type {Array<number>}
     * @memberof DeviceConnector
     */
    connectorIndices?: Array<number>;
}

/**
 * Check if a given object implements the DeviceConnector interface.
 */
export function instanceOfDeviceConnector(
    value: object,
): value is DeviceConnector {
    return true;
}

export function DeviceConnectorFromJSON(json: any): DeviceConnector {
    return DeviceConnectorFromJSONTyped(json, false);
}

export function DeviceConnectorFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceConnector {
    if (json == null) {
        return json;
    }
    return {
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        connectorIndices:
            json["connectorIndices"] == null
                ? undefined
                : json["connectorIndices"],
    };
}

export function DeviceConnectorToJSON(value?: DeviceConnector | null): any {
    if (value == null) {
        return value;
    }
    return {
        deviceIdentity: value["deviceIdentity"],
        connectorIndices: value["connectorIndices"],
    };
}
